import React, { Component } from 'react';
import map from 'lodash/map';
import get from 'lodash/get'
import plus_icon from '../../../Assets/images/plus-circle.svg';
import cross_icon from '../../../Assets/images/cross-circle.svg';


const FREQUENCY_MAPPING = {
  weekly: 'Weekly',
  bi_monthly: 'Every Other Week',
  once: 'Just Once',
  twice_weekly: 'Twice Weekly',
  monthly: 'Monthly'
};

const LAST_CLEANED_MAPPING = {
  less_than_2_weeks: 'Less than 2 weeks',
  "2-3_weeks": '2-3 weeks',
  "1-2_months": '2 to 6 weeks',
  "2_months_or_more": 'More than 6 weeks',
  "3_months_or_more": "More than 3 months"
}

const PROPERTY_TYPE_MAPPING = {
  townhouse: 'Town House',
  single_family_small: 'Detached (Less than 0.5 acres. lot)',
  single_family_large: 'Detached (More than 0.5 acres. lot)'
}

class Sidebar extends Component {
  state = {
    isApplyCoupon: false,
    coupon_code: '',
    couponCodeError: '',
    coupon_applied: {},
    is_popup_show: false
  }

  UNSAFE_componentWillMount = () => {
    let step1 = JSON.parse(sessionStorage.getItem('step1'));
    if (step1) {
      this.setState({
        coupon_code: step1.coupon_code && step1.coupon_code
      }, () => { this.applyCoupon(); })
    }

  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let step1 = JSON.parse(sessionStorage.getItem('step1'));
    if (Object.keys(props.PricingCalc.data).length > 0 && props.PricingCalc.data !== this.props.PricingCalc.data) {
      step1.coupon_code = this.state.coupon_code;
      sessionStorage.setItem('step1', JSON.stringify(step1));
      this.setState({
        coupon_applied: props.PricingCalc.data.coupon,
        isApplyCoupon: false,
        couponCodeError: ''
      })
    }
    if (Object.keys(props.PricingCalc.errors).length > 0 && props.PricingCalc.errors.coupon_code && props.PricingCalc.errors !== this.props.PricingCalc.errors) {
      delete step1.coupon_code;
      sessionStorage.setItem('step1', JSON.stringify(step1));
      this.setState({
        couponCodeError: props.PricingCalc.errors.coupon_code.toString()
      })
    }
  }

  getAdditionalAreas(pricingCalc, selectedAreas) {

    if (pricingCalc && pricingCalc.cleaning_areas && pricingCalc.cleaning_areas.items) {
      return map(pricingCalc.cleaning_areas.items, (item, i) => {
        if (item.price > 0) {
          return (
            <li key={i}>
              <label className="details">{item.area}</label>
              <span className="price">+${item.price}</span>
            </li>
          )
        }
      })
    } else if (selectedAreas?.filter(x => !x.isFirst)) {
      return selectedAreas?.filter(x => !x.isFirst).map((x, i) =>
        (
          <li key={i}>
            <label className="details">{x.display}</label>
          </li>
        )
      )
    }
  }

  // next and prev pages
  nextPage = () => {
    if (this.props.current === 0 && this.props.is_continue_btn_active) {
      this.props.goToNextStep();

    }
    this.props.Setp1Validation()
  }


  //place order validation
  placeOrder = () => {
    this.props.Step2Validation(false);
  }

  // Apply Coupon code
  applyCoupon = () => {
    let { coupon_code } = this.state;
    let step1 = JSON.parse(sessionStorage.getItem('step1'));
    let step2 = JSON.parse(sessionStorage.getItem('step2'));
    const zipcode = JSON.parse(sessionStorage.getItem('area'));

    if (step1 && coupon_code) {
      const data = {
        'field_office_uuid': step1.field_office_uuid,
        'frequency': step1.frequency,
        'pet_count': step1.pet_count === "4" ? step1.extra_pet_count : step1.pet_count,
        'last_cleaned': step1.last_cleaned,
        'property_type': step1.property_type,
        'prepay_for_year': step1.prepay_for_year,
        'add_ons': step1.add_ons,
        'areas_to_clean': step1.areas_to_clean,
        'coupon_code': coupon_code,
        'is_prepaid': this.props.is_prepaid,
        'prepay_months': this.props.is_prepaid ? this.props.prepay_months : null,
        zipcode: zipcode?.zipcode,
        address: step2?.service_address
      }
      this.setState({
        coupon_applied: {},
        couponCodeError: '',
      })

      this.props.pricingCalculator(data)
    }

  }

  addOrRemoveCoupon(applyCoupon) {
    if (!applyCoupon) {
      this.setState({ isApplyCoupon: true })
    } else {
      this.removeCouponCode();
    }
  }

  // common Pricecalc
  PriceCalc = () => {
    let { coupon_code } = this.state;
    let step1 = JSON.parse(sessionStorage.getItem('step1'));
    let step2 = JSON.parse(sessionStorage.getItem('step2'));
    const zipcode = JSON.parse(sessionStorage.getItem('area'));
    setTimeout(() => {
      if (step1) {
        const data = {
          'field_office_uuid': step1.field_office_uuid,
          'frequency': step1.frequency,
          'pet_count': step1.pet_count === "4" ? step1.extra_pet_count : step1.pet_count,
          'last_cleaned': step1.last_cleaned,
          'property_type': step1.property_type,
          'prepay_for_year': step1.prepay_for_year,
          'add_ons': step1.add_ons,
          'areas_to_clean': step1.areas_to_clean,
          'coupon_code': coupon_code,
          'is_prepaid': this.props.is_prepaid,
          'prepay_months': this.props.is_prepaid ? this.props.prepay_months : null,
          zipcode: zipcode?.zipcode,
          address: step2?.service_address

        }
        this.props.pricingCalculator(data)
      }
    }, 500);
  }

  // Remove Coupon Code
  removeCouponCode = () => {
    let step1 = JSON.parse(sessionStorage.getItem('step1'));
    let step2 = JSON.parse(sessionStorage.getItem('step2'));
    const zipcode = JSON.parse(sessionStorage.getItem('area'));
    this.setState({
      isApplyCoupon: false,
      coupon_applied: {},
      couponCodeError: '',
      coupon_code: ''
    })


    if (step1) {
      const data = {
        'field_office_uuid': step1.field_office_uuid,
        'frequency': step1.frequency,
        'pet_count': step1.pet_count === "4" ? step1.extra_pet_count : step1.pet_count,
        'last_cleaned': step1.last_cleaned,
        'property_type': step1.property_type,
        'prepay_for_year': step1.prepay_for_year,
        'add_ons': step1.add_ons,
        'areas_to_clean': step1.areas_to_clean,
        'coupon_code': "",
        'is_prepaid': this.props.is_prepaid,
        'prepay_months': this.props.is_prepaid ? this.props.prepay_months : null,
        zipcode: zipcode?.zipcode,
        address: step2?.service_address
      }
      sessionStorage.setItem('step1', JSON.stringify(data))
      this.props.pricingCalculator(data)

    }
  }

  getDisplayArray(frequency, displayPropertyType, displayArea, displayPetCount) {
    const dogs = parseInt(displayPetCount, 10) === 1 ? 'Dog' : 'Dogs'

    const returnArray = [`${FREQUENCY_MAPPING[frequency]} ${frequency !== "once" ? 'service' : ''}`];

    if (displayArea) returnArray.push(displayArea);
    if (displayPropertyType) returnArray.push(displayPropertyType);
    if (displayPetCount) returnArray.push(`${displayPetCount} ${dogs}`);

    return returnArray;
  }

  prepayTypeChange(e) {
    this.props.onPrepayTypeChange(e);
    let step1 = JSON.parse(sessionStorage.getItem('step1'));
    let step2 = JSON.parse(sessionStorage.getItem('step2'));
    const zipcode = JSON.parse(sessionStorage.getItem('area'));

    if (step1) {
      const data = {
        'is_prepaid': true,
        'field_office_uuid': step1.field_office_uuid,
        'frequency': step1.frequency,
        'pet_count': step1.pet_count === "4" ? step1.extra_pet_count : step1.pet_count,
        'last_cleaned': step1.last_cleaned,
        'property_type': step1.property_type,
        'prepay_for_year': step1.prepay_for_year,
        'prepay_months': e.target.value,
        'add_ons': step1.add_ons,
        'areas_to_clean': step1.areas_to_clean,
        zipcode: zipcode?.zipcode,
        address: step2?.service_address
      }

      this.props.pricingCalculator(data)
    }
  }

  render() {
    const { isApplyCoupon, coupon_applied, coupon_code, couponCodeError, is_popup_show } = this.state;
    const { loader, frequency, is_final_sidebar, is_footer, setLoader, is_order_placed } = this.props;
    const PricingCalc = this.props.PricingCalc.data;
    const prepay_for_year = get(this.props, 'PricingCalc.data.prepay_for_year', false);
    const frequency_price = get(this.props, 'history.location.state.query.frequency_price', {});
    const annual_prepay_discount = this.props.ZipcodeCheck && this.props.ZipcodeCheck.data.results && Object.keys(this.props.ZipcodeCheck.data.results).length > 0 ? this.props.ZipcodeCheck.data.results[0]['annual_prepay_discount'] : 0;
    const pricingCalcIsPopulated = Object.keys(PricingCalc).length > 0;

    const displayPropertyType = this.props.propertyType ? PROPERTY_TYPE_MAPPING[this.props.propertyType] : PROPERTY_TYPE_MAPPING[PricingCalc.property_type]
    const displayPetCount = this.props.petCount ? this.props.petCount : PricingCalc.pet_count;
    const displayLastCleaned = this.props.lastCleaned ? LAST_CLEANED_MAPPING[this.props.lastCleaned] : '';
    const displayArea = PricingCalc && PricingCalc.cleaning_areas && PricingCalc.cleaning_areas.items.length > 0
      ? PricingCalc.cleaning_areas.items[0].area :
      this.props.selectedAreas && this.props.selectedAreas.length > 0
        ? this.props.selectedAreas.find(x => x.isFirst)?.display : '';

    const selectionArray = this.getDisplayArray(frequency, displayPropertyType, displayArea, displayPetCount);

    const extra = ((PricingCalc && PricingCalc.cleaning_areas && PricingCalc.cleaning_areas.items.length > 1)
      || (this.props.selectedAreas && this.props.selectedAreas.filter(x => !x.isFirst).length > 0)
      || (PricingCalc && PricingCalc.recurring_add_ons && PricingCalc.recurring_add_ons.recurring_addon_items.length > 0))


    return (
      <React.Fragment>
        {!is_final_sidebar ? (
          <React.Fragment>
            <div
              className={is_popup_show ? "popup_bar show_popup" : "popup_bar "}
            >
              <div
                className="popup_header"
                onClick={() => {
                  this.setState({ is_popup_show: !is_popup_show });
                }}
              >
                <div className="toggle_btn">
                  {" "}
                  <span></span>
                </div>
                {!is_popup_show ? (
                  <React.Fragment>
                    <div className="price">
                      {this.props.frequency === "once" ? (
                        <span>Price for a single visit</span>
                      ) : (
                        <span>
                          Price per{" "}
                          {FREQUENCY_MAPPING[this.props.frequency] &&
                            FREQUENCY_MAPPING[
                              this.props.frequency
                            ].toLowerCase()}{" "}
                          visit
                        </span>
                      )}
                      {pricingCalcIsPopulated ? (
                        <label>${PricingCalc.total_price_per_service} </label>
                      ) : (
                        <label>
                          $
                          {frequency_price.min_price &&
                            frequency_price.max_price &&
                            `${frequency_price.min_price}- $${frequency_price.max_price}`}
                        </label>
                      )}
                    </div>

                    <div className="price">
                      <span>Total for first visit</span>
                      {pricingCalcIsPopulated && (
                        <label>
                          $
                          {PricingCalc &&
                            PricingCalc.total_price_for_first_visit.toFixed(2)}
                        </label>
                      )}
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
              <div
                className={
                  is_popup_show
                    ? "prepay_wrapper mt-44"
                    : "prepay_wrapper mt-84"
                }
              >
                <span>
                  Prepay for the year and save up to {annual_prepay_discount}%
                </span>
              </div>
              {is_popup_show ? (
                <React.Fragment>
                  <div className="subscription_wrapper">
                    <label className="subscription-details">
                      Subscription details
                    </label>
                    <div className="weekly-service-from">
                      <ul>
                        {selectionArray.map((x, i) => (
                          <li key={i}>
                            <label className="details">{x}</label>
                            {i === 0 && (
                              <span
                                className={
                                  PricingCalc && PricingCalc.service_base_price
                                    ? "price"
                                    : "price d-none"
                                }
                              >
                                ${PricingCalc && PricingCalc.service_base_price}
                              </span>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className={extra ? "hr" : "d-none"}></div>
                    <div className="weekly-service-from">
                      <ul>
                        {this.getAdditionalAreas(
                          PricingCalc,
                          this.props.selectedAreas
                        )}
                      </ul>
                      <ul>
                        {map(
                          PricingCalc &&
                            PricingCalc.recurring_add_ons &&
                            PricingCalc.recurring_add_ons.recurring_addon_items,
                          (item, i) => {
                            if (item.type === "add_on") {
                              return (
                                <li key={i}>
                                  <label className="details">{item.name}</label>
                                  <span className="price">+${item.price}</span>
                                </li>
                              );
                            }
                          }
                        )}
                      </ul>
                    </div>
                  </div>
                  <div className="price_per">
                    <div className="title">
                      {this.props.frequency === "once" ? (
                        <label>Price for a single visit</label>
                      ) : (
                        <label>
                          Price per{" "}
                          {FREQUENCY_MAPPING[this.props.frequency] &&
                            FREQUENCY_MAPPING[
                              this.props.frequency
                            ].toLowerCase()}{" "}
                          visit
                        </label>
                      )}
                      <span>{`Billed ${
                        frequency === "once" ? "Just Once" : "Monthly"
                      }`}</span>
                    </div>
                    <div className="price">
                      {pricingCalcIsPopulated ? (
                        <label>${PricingCalc.total_price_per_service} </label>
                      ) : (
                        <label>
                          $
                          {frequency_price.min_price &&
                            frequency_price.max_price &&
                            `${frequency_price.min_price}- $${frequency_price.max_price}`}
                        </label>
                      )}
                    </div>
                  </div>
                  <div className="one_time">
                    <div className="title">
                      <label>
                        One-time charge<span>(s)</span>
                      </label>
                      {PricingCalc.cleaning_areas ? (
                        map(
                          PricingCalc &&
                            PricingCalc.one_time_charges &&
                            PricingCalc.one_time_charges.one_time_items,
                          (item, i) => {
                            if (item.type === "last_clean") {
                              return (
                                <span key={i}>
                                  {" "}
                                  {LAST_CLEANED_MAPPING[item.name]} since last
                                  clean{" "}
                                </span>
                              );
                            }
                            return (
                              <span className="since-las" key={i}>
                                {item.name}
                              </span>
                            );
                          }
                        )
                      ) : displayLastCleaned ? (
                        <span className="since-las">
                          {" "}
                          {displayLastCleaned} since last clean{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>

                    {PricingCalc && PricingCalc.one_time_charges && (
                      <div className="price">
                        <label>
                          +$
                          {
                            PricingCalc.one_time_charges
                              .total_one_time_charge_before_coupon
                          }
                        </label>
                      </div>
                    )}
                  </div>
                  <div className="total_for">
                    <label>Total for first visit</label>
                    {pricingCalcIsPopulated && (
                      <span>
                        $
                        {PricingCalc &&
                          PricingCalc.total_price_for_first_visit.toFixed(2)}
                      </span>
                    )}
                  </div>

                  <div className="footer_desc">
                    <label>
                      Questions about your quote?{" "}
                      <a href="https://www.doodycalls.com/contact-us/">
                        Request more information, chat
                      </a>{" "}
                      or call us at 1-800-366-3922 and we’ll walk you through
                      it. We are available Mon-Fri from 8AM to 9PM EST and
                      Saturday and Sunday from 12PM - 5PM EST.
                    </label>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
            <div className={is_popup_show ? "overlay_mask" : ""}></div>
          </React.Fragment>
        ) : (
          ""
        )}

        <React.Fragment>
          <div
            className={
              is_final_sidebar && is_footer
                ? "sidebar show_final_sidebar"
                : "sidebar"
            }
          >
            <div className="title_details">
              <h3>Service Summary</h3>
              <label className="subscription-details">
                Subscription details
              </label>
            </div>
            <div
              className={
                PricingCalc &&
                PricingCalc.cleaning_areas &&
                PricingCalc.cleaning_areas.items.length > 0
                  ? "weekly-service-from "
                  : "weekly-service-from service-from-height"
              }
            >
              <ul>
                {selectionArray.map((x, i) => (
                  <li key={i}>
                    <label className="details">{x}</label>
                    {i === 0 && (
                      <span
                        className={
                          PricingCalc && PricingCalc.service_base_price
                            ? "price"
                            : "price d-none"
                        }
                      >
                        ${PricingCalc && PricingCalc.service_base_price}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className={extra ? "hr" : "d-none"}></div>
            <div className={extra ? "weekly-service-from" : "d-none"}>
              <ul>
                {this.getAdditionalAreas(PricingCalc, this.props.selectedAreas)}
              </ul>
              <ul>
                {map(
                  PricingCalc &&
                    PricingCalc.recurring_add_ons &&
                    PricingCalc.recurring_add_ons.recurring_addon_items,
                  (item, i) => {
                    if (item.type === "add_on") {
                      return (
                        <li key={i}>
                          <label className="details">{item.name}</label>
                          <span className="price">+${item.price}</span>
                        </li>
                      );
                    }
                  }
                )}
              </ul>
            </div>
            <div className="price-per-weekly wizard_price-per-weekly">
              <div
                className={prepay_for_year ? "d-none" : "heading_wrapper"}
                style={
                  this.props.frequency === "once" ? { marginBottom: 0 } : {}
                }
              >
                <div className="heading">
                  {this.props.frequency === "once" ? (
                    <h4>Price for a single visit</h4>
                  ) : (
                    <h4>
                      Price per{" "}
                      {FREQUENCY_MAPPING[this.props.frequency] &&
                        FREQUENCY_MAPPING[
                          this.props.frequency
                        ].toLowerCase()}{" "}
                      visit
                    </h4>
                  )}
                  <span className="billed-monthly">{`Billed ${
                    frequency === "once" ? "Just Once" : "Monthly"
                  }`}</span>
                </div>
                {pricingCalcIsPopulated ? (
                  <div className="price">
                    ${PricingCalc.total_price_per_service}{" "}
                  </div>
                ) : (
                  <div className="price">
                    $
                    {frequency_price.min_price &&
                      frequency_price.max_price &&
                      `${frequency_price.min_price}- $${frequency_price.max_price}`}
                  </div>
                )}
              </div>
              {frequency !== "once" && (
                <div className="checkbox_wrapper">
                  <div className="chk_label">
                    <label>
                      Prepay and save up to {annual_prepay_discount}%
                    </label>
                    <p className={this.props.is_prepaid ? "" : "d-none"}>
                      Cancel any time to receive a <br /> refund for the unused
                      amount.
                    </p>
                  </div>
                  <div className="chk_switch">
                    <div className="can-toggle can-toggle--size-small">
                      <input
                        id="prepay_for_year"
                        type="checkbox"
                        checked={!this.props.is_prepaid}
                        onChange={(e) => {
                          this.PriceCalc();
                          this.props.onPrepayChange(e);
                        }}
                      />
                      <label htmlFor="prepay_for_year">
                        <div
                          className="can-toggle__switch"
                          data-unchecked="Yes"
                          data-checked="No"
                        ></div>
                      </label>
                    </div>
                  </div>
                </div>
              )}
              {this.props.is_prepaid && (
                <div className="price_type">
                  {pricingCalcIsPopulated && PricingCalc.prepay_price && (
                    <ul className="price_type_list">
                      <li
                        className={
                          this.props.prepay_months === "6" ||
                          this.props.prepay_months === null
                            ? ""
                            : "disble_sub_type"
                        }
                      >
                        <div className="checkbox_wrapper">
                          <input
                            id="6_month"
                            checked={this.props.prepay_months === "6"}
                            value="6"
                            name="price_type"
                            type="radio"
                            onChange={(e) => {
                              this.props.onPrepayTypeChange(e);
                              this.PriceCalc();
                            }}
                          />
                          <label htmlFor="6_month">
                            {/* Price for 6 months */}6 Mos Prepay Cost
                            {/* 6 Mos Prepay Cost/Visit */}
                            <span>
                              Save $
                              {PricingCalc.prepay_price.six_months.savings.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}{" "}
                              (5%)
                            </span>
                          </label>
                        </div>

                        {/* <span className="price">${PricingCalc.prepay_price.six_months.price_after_discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span> */}
                        <span className="price">
                          $
                          {(PricingCalc?.prepay_price?.six_months?.total_price_per_service).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}{" "}
                        </span>
                      </li>
                      <li
                        className={
                          this.props.prepay_months === "12" ||
                          this.props.prepay_months === null
                            ? ""
                            : "disble_sub_type"
                        }
                      >
                        <div className="checkbox_wrapper">
                          <input
                            id="12_month"
                            checked={this.props.prepay_months === "12"}
                            value="12"
                            name="price_type"
                            type="radio"
                            onChange={(e) => {
                              this.props.onPrepayTypeChange(e);
                              this.PriceCalc();
                            }}
                          />
                          <label htmlFor="12_month">
                            {/* Price for 1 year */}
                            12 Mos Prepay Cost
                            {/* 12 Mos Prepay Cost/Visit */}
                            <span>
                              Save $
                              {PricingCalc.prepay_price.twelve_months.savings.toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}{" "}
                              (10%)
                            </span>
                          </label>
                        </div>
                        {/* <span className="price">${PricingCalc.prepay_price.twelve_months.price_after_discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span> */}
                        <span className="price">
                          $
                          {(PricingCalc?.prepay_price?.twelve_months?.total_price_per_service).toLocaleString(
                            "en-US",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}{" "}
                        </span>
                      </li>
                    </ul>
                  )}
                </div>
              )}
            </div>
            <div className="one-time-charges">
              <div className="label_wrapper">
                <h4>One-time charge(s)</h4>
                <div>
                  {PricingCalc.cleaning_areas ? (
                    map(
                      PricingCalc &&
                        PricingCalc.one_time_charges &&
                        PricingCalc.one_time_charges.one_time_items,
                      (item, i) => {
                        if (item.type === "last_clean") {
                          return (
                            <p className="since-las" key={i}>
                              {" "}
                              {LAST_CLEANED_MAPPING[item.name]} since last clean{" "}
                            </p>
                          );
                        }
                        return (
                          <p className="since-las" key={i}>
                            {item.name}
                          </p>
                        );
                      }
                    )
                  ) : displayLastCleaned ? (
                    <p className="since-las">
                      {" "}
                      {displayLastCleaned} since last clean{" "}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {pricingCalcIsPopulated && (
                <label className="price">
                  +$
                  {PricingCalc &&
                    PricingCalc.one_time_charges &&
                    PricingCalc.one_time_charges.total_one_time_charge}
                </label>
              )}
            </div>
            <div className="total_wrapper">
              <div className="total_price">
                <label className="title">Total for first visit</label>
                {pricingCalcIsPopulated && (
                  <span className="price">
                    $
                    {PricingCalc && this.props.is_prepaid
                      ? this.props.prepay_months === "12"
                        ? PricingCalc?.prepay_price?.twelve_months?.total_price_for_first_visit.toFixed(
                            2
                          )
                        : this.props.prepay_months === "6"
                        ? PricingCalc?.prepay_price?.six_months?.total_price_for_first_visit.toFixed(
                            2
                          )
                        : PricingCalc.total_price_for_first_visit.toFixed(2)
                      : PricingCalc.total_price_for_first_visit.toFixed(2)}
                  </span>
                )}
              </div>

              {coupon_applied && coupon_applied.coupon_applied ? (
                <div className="applied_coupon_code">
                  <div>
                    <img
                      src={cross_icon}
                      className="mr-1 cross_icon"
                      alt=""
                      onClick={(e) => {
                        this.removeCouponCode(e);
                      }}
                    />
                  </div>
                  <div
                    className="current_code"
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    <label>
                      {coupon_applied && coupon_applied.coupon_applied}
                    </label>
                    <br />
                    <span style={{ margin: "auto" }}>
                      Discount applied and the invoice will be charged
                      accordingly
                    </span>
                  </div>
                  <div className="discount_price">
                    {coupon_applied && coupon_applied.savings
                      ? `-$${coupon_applied.savings}`
                      : "$0"}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            {this.props.is_prepaid &&
            pricingCalcIsPopulated &&
            this.props.prepay_months ? (
              <span className="prepay_price">
                {PricingCalc &&
                PricingCalc.prepay_price_after_coupon_discount ? (
                  <React.Fragment>
                    <table style={{ width: "100%" }}>
                      <tr>
                        <td style={{ width: "80%", padding: "5px 0px" }}>
                          Your total pre-pay amount{" "}
                        </td>
                        <td
                          align="right"
                          style={{ width: "20%", padding: "5px 0px" }}
                        >
                          <b>
                            $
                            {PricingCalc.prepay_price_after_coupon_discount.toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: "80%", padding: "5px 0px" }}>
                          plus any applicable taxes
                        </td>
                        <td
                          align="right"
                          style={{ width: "20%", padding: "5px 0px" }}
                        >
                          <b>
                            $
                            {PricingCalc.prepay_tax.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: "80%", padding: "5px 0px" }}>
                          Your total to pay today is{" "}
                        </td>
                        <td
                          align="right"
                          style={{ width: "20%", padding: "5px 0px" }}
                        >
                          <b>
                            $
                            {PricingCalc.net_payable_prepay_amount.toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </b>
                        </td>
                      </tr>
                    </table>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </span>
            ) : (
              ""
            )}
            <div className="add-a-coupon">
              <div className="apply_coupon">
                <div className="apply_coupon_icon">
                  <img
                    src={plus_icon}
                    alt=""
                    style={isApplyCoupon ? { display: "none" } : {}}
                    onClick={() => this.addOrRemoveCoupon(isApplyCoupon)}
                  />
                  <img
                    src={cross_icon}
                    alt=""
                    style={isApplyCoupon ? {} : { display: "none" }}
                    onClick={() => this.addOrRemoveCoupon(isApplyCoupon)}
                  />
                </div>
                {isApplyCoupon ? (
                  <div className="add_coupon_wrapper">
                    <input
                      type="text"
                      className={
                        couponCodeError
                          ? "form--control error_control"
                          : "form--control"
                      }
                      name="coupon_code"
                      value={coupon_code}
                      onChange={(e) =>
                        this.setState({ [e.target.name]: e.target.value })
                      }
                    />
                    <a
                      href="/#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.applyCoupon();
                      }}
                      className="apply_coupon_btn"
                    >
                      Add
                    </a>
                  </div>
                ) : (
                  <span onClick={() => this.addOrRemoveCoupon(isApplyCoupon)}>
                    Add a coupon
                  </span>
                )}
              </div>
            </div>
            {couponCodeError ? (
              <label className={couponCodeError ? "err_msg" : ""}>
                {couponCodeError}
              </label>
            ) : (
              ""
            )}
            {is_final_sidebar ? (
              <div className="sidebar_note mobile_sidebar_note">
                <p>
                  Questions about your quote? Request more information,{" "}
                  <a
                    href="https://www.doodycalls.com/contact-us/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    chat
                  </a>{" "}
                  or call us at 1-800-366-3922 and we’ll walk you through it. We
                  are available Mon-Fri from 8AM to 9PM EST and Saturday and
                  Sunday from 12PM - 5PM EST.
                </p>
              </div>
            ) : (
              ""
            )}
            <div className="submit_btn">
              {this.props.current === 0 ? (
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    this.nextPage();
                  }}
                >
                  Continue
                </button>
              ) : (
                <button
                  type="button"
                  // disabled={!this.props.is_checkout_btn_active || (this.props.is_prepaid && this.props.prepay_months == null)}
                  onClick={() => {
                    if (!is_order_placed) {
                      this.setState({ is_order_placed: true }, () => {
                        setLoader(true);
                        this.placeOrder();
                      });
                    }
                  }}
                  // className={!this.props.is_checkout_btn_active || (this.props.is_prepaid && this.props.prepay_months == null) ? 'disable_btn btn' : 'btn'}
                  className="btn"
                >
                  Checkout
                </button>
              )}
            </div>
          </div>
          <div className="sidebar_note">
            <p>
              Questions about your quote?{" "}
              <a href="https://www.doodycalls.com/contact-us/">
                Request more information, chat
              </a>{" "}
              or call us at 1-800-366-3922 and we’ll walk you through it. We are
              available Mon-Fri from 8AM to 9PM EST and Saturday and Sunday from
              12PM - 5PM EST.
            </p>
          </div>
          {loader && (
            <div className="loader_wrapper">
              <div className="loader07"></div>
            </div>
          )}
        </React.Fragment>
      </React.Fragment>
    );
  }
}

export default Sidebar;